import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { links, constants } from 'common/helpers'
import { useFeatures } from 'sb-hooks'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'

import Button from 'components/buttons/Button/Button'

import messages from './messages'
import s from './WeMissedYouContent.scss'

import mariyaImage from './images/mariya@2x.png'
import birdImage from './images/bird@2x.png'


const WeMissedYouContent = ({
  firstName, countOfClosings, hasLEPInQueueFirstMonth, isLEPNeedUpdateCard, currentMonth, onClose,
}) => {
  const { [constants.features.billingDay1stDayOfTheMonth]: isBillingDay1stEnabled } = useFeatures()

  const imageBoxClassName = 'imageBox'
  const textContainerClassName = cx(s.textContainer, {
    [s.modal1]: !countOfClosings,
    [s.modal2]: countOfClosings,
  })

  return (
    <Fragment>
      <div className={textContainerClassName}>
        {
          Boolean(countOfClosings) ? (
            <div className={imageBoxClassName}>
              <img className={s.birdImage} src={birdImage} alt="" />
            </div>
          ) : (
            <div className={imageBoxClassName}>
              <img className={s.mariyaImage} src={mariyaImage} alt="" />
              <FormattedHTMLMessage
                className={s.imageCaption}
                {...messages.imageCaption}
              />
            </div>
          )
        }
        <div className={s.messageBox}>
          <FormattedHTMLMessage
            className={s.bold}
            {...messages.firstName}
            values={{ firstName }}
          />
          {
            (() => {
              if (isLEPNeedUpdateCard) {
                return (
                  <FormattedHTMLMessage tag="div" {...messages.textLEPNeedUpdateCard} />
                )
              }

              if (hasLEPInQueueFirstMonth) {
                const message = isBillingDay1stEnabled ? messages.textWithLEPInfo1st : messages.textWithLEPInfo

                return (
                  <FormattedHTMLMessage tag="div" {...message} values={{ currentMonth }} />
                )
              }

              return (
                <Fragment>
                  <FormattedHTMLMessage tag="div" {...messages.text} />
                  <FormattedMessage {...messages.subText} />
                </Fragment>
              )
            })()
          }
        </div>
      </div>
      <Button
        className={s.button}
        title={messages.button}
        brand
        to={links.cardUpdate}
        onClick={onClose}
      />
      <FormattedHTMLMessage className={s.contactInfo} {...messages.contactInfo} />
    </Fragment>
  )
}

WeMissedYouContent.propTypes = {
  firstName: PropTypes.string,
  countOfClosings: PropTypes.number,
  hasLEPInQueueFirstMonth: PropTypes.bool,
  isLEPNeedUpdateCard: PropTypes.bool,
  currentMonth: PropTypes.string,
  onClose: PropTypes.func.isRequired,
}

WeMissedYouContent.defaultProps = {
  firstName: '',
  countOfClosings: 0,
  hasLEPInQueueFirstMonth: false,
  isLEPNeedUpdateCard: false,
}


export default WeMissedYouContent
